export * from './simple-layout.component';



// WEBPACK FOOTER //
// C:/repos/Tulaima/Tulaima-ng/src/app/containers/simple-layout/index.ts